module.exports = __webpack_public_path__ + "static/donald-glover-77ce6493dc786a10536c91eb6dfb9fa7.jpg";